import { gql } from '@common/hooks';
import { SupplierType, OrganizationType } from '@institutions/types';

export const CreateSupplierInvitationMutation = gql`
  mutation CreateSupplierInvitation($suppliers: [SuppliersInvitationInput!]!) {
    createSupplierInvitation(suppliers: $suppliers) {
      suppliers {
        id
        name
      }
      organization {
        id
        name
      }
      createdBy {
        id
        name
      }
    }
  }
`;

export type WorksMembership = {
  id: string;
  name: string;
};

export type CreateSupplierInvitationResponse = {
  createSupplierInvitation: {
    suppliers: Partial<SupplierType>[];
    organization: Partial<OrganizationType>;
    createdBy: WorksMembership;
  };
};

export type CreateSupplierInvitationVariables = {
  suppliers: {
    id: string;
    message: string;
  }[];
};
